import React from 'react'

const Recruitment = () => {
  return (
    <div className='text-2xl font-semibold font-sans text-[#2F345A] '>Recruitment</div>
  )
}

export default Recruitment